import { useRoutes } from "react-router";
import { lazy } from "react";
import { retry } from "../common/commonFunctions";

const LandingPage = lazy(() => retry(() => import("../pages/LandingPage")));
const ContactUs = lazy(() => retry(() => import("../pages/ContactUs")));
const Careers = lazy(() => retry(() => import("../pages/Careers")));

const Routes = () => {
  const routes = useRoutes([
    {
      path: "/",
      element: <LandingPage />,
    },
    {
      path: "/careers",
      element: <Careers />,
    },
    {
      path: "/contact-us",
      element: <ContactUs />,
    },
  ]);
  return routes;
};

export default Routes;
